export { default as crashMobileImg } from './crash-mobile.svg';
export { default as crashImg } from './crash.svg';
export { default as glassMobileImg } from './glass-mobile.svg';
export { default as glassImg } from './glass.svg';
export { default as highwayMobileImg } from './highway-mobile.svg';
export { default as highwayImg } from './highway.svg';
export { default as liabilityMobileImg } from './liability-mobile.svg';
export { default as liabilityImg } from './liability.svg';
export { default as stolenMobileImg } from './stolen-mobile.svg';
export { default as stolenImg } from './stolen.svg';
export { default as unexpectedMobileImg } from './unexpected-mobile.svg';
export { default as unexpectedImg } from './unexpected.svg';
